import './component-tiles.scss';

import Masonry from 'masonry-layout';
import { Slider } from '../slider/slider';

class ComponentTiles {
    constructor (element, options) {
        const defaults = {
            initAttr: 'data-component-tiles',
            content: 'content',
            toggleAttr: 'toggle',
            itemsAttr: 'slides',
            itemAttr: 'slide',
            contentAttr: 'content',
            mobile: false
        };

        this.settings = Object.assign({}, defaults, options);
        this.$componentTiles = element;

        this.$itemsWrapper = this.$componentTiles.querySelector('[' + this.settings.initAttr + '="' + this.settings.itemsAttr + '"]');
        this.$content = this.$componentTiles.querySelector('[' + this.settings.initAttr + '="' + this.settings.contentAttr + '"]');
        this.$$items = this.$componentTiles.querySelectorAll('[' + this.settings.initAttr + '="' + this.settings.itemAttr + '"]');
        this.$$toggle = this.$componentTiles.querySelectorAll('[' + this.settings.initAttr + '="' + this.settings.toggleAttr + '"]');
        this.mobile = null;
        this.slider = false;
        this.masonry = false;
        this.view = this.getCheckedButton(this.$$toggle);
    }

    initialize () {
        if (window.matchMedia('(max-width: 767px)').matches) {
            this.mobile = true;
        } else {
            this.mobile = false;
        }

        this.setState(this.view);
        this.setEvents();
    }

    initSlider (slider) {
        this.slider = new Slider(slider, {
            initAttr: this.settings.initAttr,
            autoHeight: true,
            calculateHeight: false,
            prevnext: false,
            speed: 750
        });
    }

    destroySlider () {
        if (typeof this.slider === 'object') {
            this.slider.destroy();
            this.slider = false;
        }
    }

    initMasonry ($obj) {
        let size = '';

        if (this.$componentTiles.querySelectorAll('.component-tiles__item--s').length > 0) {
            size = '.component-tiles__item--s';
        } else if (this.$componentTiles.querySelectorAll('.component-tiles__item--m').length > 0) {
            size = '.component-tiles__item--m';
        } else if (this.$componentTiles.querySelectorAll('.component-tiles__item--l').length > 0) {
            size = '.component-tiles__item--l';
        }

        this.masonry = new Masonry($obj, {
            itemSelector: '.component-tiles__item',
            columnWidth: size,
            percentPosition: true
        });
    }

    getCheckedButton (buttons) {
        for (let i = 0; i < buttons.length; i++) {
            if (buttons[i].checked) {
                this.view = buttons[i].value;
            }
        }

        return this.view;
    }

    destroyMasonry () {
        if (typeof this.masonry === 'object') {
            this.masonry.destroy();
            this.masonry = false;
        }
    }

    setState (view) {
        if (this.mobile === false) {
            this.destroySlider();
            this.initMasonry(this.$itemsWrapper);
        } else {
            this.destroyMasonry();
            if (view === 'slider') {
                this.initSlider(this.$content);
            } else {
                this.destroySlider();
            }
        }
    }

    setEvents () {
        document.addEventListener('design_s', () => {
            this.mobile = true;
            this.setState(this.view);
        });

        document.addEventListener('design_m', () => {
            this.mobile = false;
            this.setState('masonry');
        });

        document.addEventListener('design_l', () => {
            this.mobile = false;
            this.setState('masonry');
        });

        this.$$toggle.forEach(button => {
            button.addEventListener('change', () => {
                this.view = button.value;
                this.setState(this.view);
            });
        });
    }
}

export { ComponentTiles };

window.addEventListener('content.loaded', (e) => {
    const eventDetails = e.detail;
    const $context = eventDetails.$context;

    if ($context) {
        const $$ComponentTiles = $context.querySelectorAll('[data-component-tiles="root"]');
        for (let i = 0; i < $$ComponentTiles.length; i++) {
            const $ComponentTiles = new ComponentTiles($$ComponentTiles[i]);
            $ComponentTiles.initialize();
        }
    }
});
